module.exports = __webpack_public_path__ + "img/bitkub.366eee1a.jpg";